export default __webpack_public_path__ + "static/media/preloader.d16c2637.gif";